import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import ConsumerPathwayCareerAcademyPageSEO from 'bundles/unified-career-academy/components/ConsumerPathwayCareerAcademyPageSEO';
import { usePageData } from 'bundles/unified-career-academy/contexts/ConsumerPathwayCareerAcademyPageDataContext';
import ArticlesCollectionModuleRenderer from 'bundles/unified-career-academy/module-renderers/ArticlesCollectionModuleRenderer';
import CareerAcademyModuleRenderer from 'bundles/unified-career-academy/module-renderers/CareerAcademyModuleRenderer';
import OnboardingModuleRenderer from 'bundles/unified-career-academy/module-renderers/OnboardingModuleRenderer';
import TestimonialsModuleRenderer from 'bundles/unified-career-academy/module-renderers/TestimonialsModuleRenderer';
import HeroModuleRenderer from 'bundles/unified-career-academy/module-renderers/hero-module/CareerAcademyPageHeroModuleRenderer';
import { getPathwayDisclaimer } from 'bundles/unified-common/utils/getPathwaysDisclaimers';

export const ConsumerPathwayCareerAcademyPageRootContent = () => {
  const pageData = usePageData();

  if (pageData?.loading) {
    // TODO: Add loading state
    // https://coursera.atlassian.net/browse/MERCH-681
    return null;
  }

  return (
    <div>
      <HeroModuleRenderer pageData={pageData} />
      <CareerAcademyModuleRenderer />
      <OnboardingModuleRenderer />
      <ArticlesCollectionModuleRenderer pageData={pageData} />
      <TestimonialsModuleRenderer pageData={pageData} />
      <CitationModule citations={getPathwayDisclaimer()} removeTopPadding />
      <ConsumerPathwayCareerAcademyPageSEO />
    </div>
  );
};

export default ConsumerPathwayCareerAcademyPageRootContent;
